
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/koleksiyonlar-ve-arastirmalar/arsiv-ve-arastirma-alani/[slug]/[caseStudyId]",
      function () {
        return require("private-next-pages/koleksiyonlar-ve-arastirmalar/arsiv-ve-arastirma-alani/[slug]/[caseStudyId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/koleksiyonlar-ve-arastirmalar/arsiv-ve-arastirma-alani/[slug]/[caseStudyId]"])
      });
    }
  